import { useEffect } from "react"
import { TShowFormContentDialog } from "./types"
import { CircularProgress, DialogHandler, TagsFactory } from "@cakemail-org/ui-components-v2"
import { getBaseForm } from "../../baseContent/baseForm"
import { useTranslation } from "react-i18next"


export function showFormContentDialog({ resolve, reject, args, getContentContext }: TShowFormContentDialog) {
    DialogHandler.show({
        content: <FormContentDialog resolve={resolve} reject={reject} args={args} getContentContext={getContentContext} />,
    })
}

export function FormContentDialog({ resolve, reject, args, getContentContext }: TShowFormContentDialog) {
    const { t } = useTranslation()

    useEffect(() => {
        const context = getContentContext()
        const formBaseStructure = getBaseForm()
        formBaseStructure.structure.attributes.action = context?.formAction || ""

        //TODO cache api calls for 10 minutes
        // deleteStorageItem({ key: EEditorCacheKeys.listAttributes, type: EStorageType.session })
        //deleteStorageItem({ key: EEditorCacheKeys.listInterests, type: EStorageType.session })
        //deleteStorageItem({ key: EEditorCacheKeys.tags, type: EStorageType.session })


        Promise.all([
            fetchCustomAttributes(),
            fetchInterests(),
            fetchTags()
        ]).then(([customAttributes, interests, tags]) => {

            customAttributes.forEach((attribute) => {
                formBaseStructure.structure.fields[attribute.name] = {
                    type: "text",
                    attributes: {
                        name: `custom_attributes[${attribute.name}]`,
                    },
                    label: attribute.name,
                    removeFromLayout: true,
                    canBeRemovedFromLayout: true,
                }
            })


            formBaseStructure.structure.fields["interests"] = {
                type: "checkbox",
                label: t("general-interest_other"),
                attributes: {
                    name: "interests[]",
                },
                options: interests.map((interest) => ({
                    label: interest.alias || interest.name,
                    value: interest.name,
                })),
                removeFromLayout: true,
                canBeRemovedFromLayout: true,
            }

            formBaseStructure.structure.fields["tags"] = {
                type: "checkbox",
                label: t("general-tag_other"),
                attributes: {
                    name: "tags[]",
                },
                options: tags.map((tag) => ({
                    label: tag.tag,
                    value: tag.tag,
                })),
                removeFromLayout: true,
                canBeRemovedFromLayout: true,
            }

            /*
            tags.forEach((ta) => {
                formBaseStructure.structure.fields[ta.tag + "-tags"] = {
                    type: "hidden",
                    label: ta.tag + " - hidden",

                    removeFromLayout: true,
                    canBeRemovedFromLayout: true,
                }
            }),
*/

            formBaseStructure.structure.layout = []
            Object.keys(formBaseStructure.structure.fields).forEach((field) => {
                if (field === "email" || field === "submit_button") {
                    return
                }
                formBaseStructure.structure.layout.push([field])
            })
            formBaseStructure.structure.layout.unshift(["email"])
            formBaseStructure.structure.layout.push(["submit_button"])

            DialogHandler.hide()
            resolve(formBaseStructure)

        }).catch((error) => {
            DialogHandler.hide()
            resolve(formBaseStructure)
        })

    }, [])

    async function fetchCustomAttributes() {
        const context = getContentContext()
        const list = context.list
        if (list) {
            return list.getAttributes({ perPage: 200 }).then((attributes) => {
                return attributes.data
            }).catch((error) => {
                return []
            })
        }

        return []
    }
    async function fetchInterests() {
        const context = getContentContext()
        const list = context.list
        if (list) {
            return list.getInterests({ perPage: 200 }).then((interests) => {
                return interests.data
            }).catch((error) => {
                return []
            })
        }
        return []
    }
    async function fetchTags() {
        return TagsFactory.list({ perPage: 200 }).then((tags) => {
            return tags.data
        }).catch((error) => {
            return []
        })
    }

    return <CircularProgress variant="indeterminate" />
}